import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'ca-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, MatIcon, MatTooltip]
})
export class TagComponent {
    public type = input<string>();
    public tooltip = input<string>();
    public outline = input<boolean>(false);
    public rounded = input<boolean>(false);
}
